import React from 'react';
import Footer from '../footer/Footer';
import { connect } from 'react-redux'
import { returnFromRegistered, fetchEvent, clearEditState} from '../../actions'
import { Table, Divider } from 'semantic-ui-react'
import ReactGA from 'react-ga';
import ReactToExcel from 'react-html-table-to-excel'

class Registered extends React.Component {
    
  onReturn = (formValues) => {
    this.props.returnFromRegistered(); 
  }    
 
  handleClick(e) {
    e.preventDefault();
  }

  componentDidMount(){
      ReactGA.ga('send', 'pageview', '/registeredList');
      this.props.fetchEvent(this.props.match.params.eventId, this.props.match.params.event_date);
  }

  componentWillUnmount(){
    this.props.clearEditState();
  }

  render () {
    
    if(!this.props.edits.editEvent){
        return (
            <React.Fragment>
                <div className="ui container">
                <h2>No Players Registered</h2>
                <button className="ui button primary" onClick={this.onReturn}>
                    Return
                  </button>
                </div>
                <Footer/>
            </React.Fragment>
        )
    }
    
    return (
        <React.Fragment>
            <div className="ui container">
                {/* <h2>Results</h2> */}
                <Divider hidden/>
                
                <h2>Registered Players for:  {this.props.edits.editEvent.event_name +', '+ this.props.edits.editEvent.event_location}.</h2>
                <h2>Date: {this.props.edits.editEvent.event_day + '-' + this.props.edits.editEvent.event_month + '-' +this.props.edits.editEvent.event_year}</h2>
                <h3> 
                </h3>

                <ReactToExcel
                    table = 'regTable'
                    filename = 'Registered'
                    sheet='Registered'
                    buttonText='Export all registered to Excel'
                />
                <Table celled striped id='regTable'>
                    <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Team/Pairs</Table.HeaderCell>
                        <Table.HeaderCell>Player Names</Table.HeaderCell>
                    </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        { (this.props.edits.editEvent.registered)? renderRegisteredTable(this.props.edits.editEvent.registered) : '' }
                    </Table.Body>
                </Table>
                <button className="ui button primary" onClick={this.onReturn}>
                    Return
                </button>
            </div>
            <Footer/>
        </React.Fragment>
    )
    }
} 

const renderRegisteredTable = (registered) => registered.map((reg, index) => {
    const {player1, player2, player3, player4} = reg;
    return (
        <Table.Row>
            <Table.Cell>Group {index+1}</Table.Cell>
            <Table.Cell>
            {player1}<br/>{player2}<br/>{player3}<br/>{player4}<br/></Table.Cell>
        </Table.Row>
    ) 
});

const mapStateToProps = (state, ownProps) => {
  return {
    edits: state.edits
  };  
}

export default connect(mapStateToProps, {clearEditState, returnFromRegistered, fetchEvent})(Registered)